import React, { FC } from "react";
import Header from "../../components/Common/Header/Header";
import Footer from "../../components/Common/Footer/Footer";
import { LegalPageBlock, LegalPageContent, LegalPageSection, LegalPageSectionTitle, LegalPageSubtitle, LegalPageText, LegalPageTitle } from "./LegalPageStyles";

interface LegalSection {
  title: string;
  paragraphs: string[];
}

interface LegalPageProps {
  title: string;
  subtitle?: string;
  sections: LegalSection[];
}

const LegalPage: FC<LegalPageProps> = ({ title, subtitle, sections }) => {
  return (
    <LegalPageBlock>
      <Header />
      <LegalPageContent>
        <LegalPageTitle>{title}</LegalPageTitle>
        {subtitle && <LegalPageSubtitle>{subtitle}</LegalPageSubtitle>}
        {sections.map((section) => (
          <LegalPageSection key={section.title}>
            <LegalPageSectionTitle>{section.title}</LegalPageSectionTitle>
            {section.paragraphs.map((paragraph) => (
              <LegalPageText key={paragraph}>{paragraph}</LegalPageText>
            ))}
          </LegalPageSection>
        ))}
      </LegalPageContent>
      <Footer />
    </LegalPageBlock>
  );
};

export default LegalPage;
